<script setup lang="ts">
import CommonBtn from '@/components/common-btn/CommonBtn.vue'
import { ElMessage } from 'element-plus'

const envMode = import.meta.env.VITE_ENV_MODE

function handleCopyGroupNumber() {
  navigator.clipboard.writeText(envMode === 'test' ? '753722049' : '474754087')
  ElMessage.success('复制成功')
}

function handleJoinGroupByLink() {
  if (envMode === 'test') {
    window.open(
      'http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=XA1kV8ToVnnT8dqaHreLIvrzL9FyYKCK&authKey=le52Cz0ezQFq8MWxkW8LVD0pB%2Bl1LdYO068lfGw6K%2FYulSHpWl87jeY68%2F7X%2BDRZ&noverify=0&group_code=753722049',
    )
  } else {
    window.open('https://qm.qq.com/q/cHXLFGxGbm')
  }
}
</script>

<template>
  <h2>加入官方QQ群，享多重福利</h2>
  <p><b>实时资讯</b>，获取第一手更新信息、兑换码</p>
  <p><b>攻略分享</b>，群内高手云集，大家可畅言装备搭配心得</p>
  <p><b>反馈建议</b>，觉得游戏不够好，提出想法，同时还有钻石奖励</p>
  <p>群号：{{ envMode === 'test' ? '753722049' : '474754087' }}</p>
  <div class="btn-wrap">
    <CommonBtn type="success" @done="handleCopyGroupNumber">复制群号</CommonBtn>
    <CommonBtn @done="handleJoinGroupByLink">通过链接加入</CommonBtn>
  </div>
</template>

<style lang="scss" scoped></style>
